import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./timeline.css";

gsap.registerPlugin(ScrollTrigger);

function initTimelineReveal() {
  const timelineItems = document.querySelectorAll(".timeline-item");
  const timeline = document.querySelector(".timeline");
  const timelineProgress = document.querySelector(".timeline-line-progress");

  if (!timelineItems.length) return;

  ScrollTrigger.getAll().forEach((trigger) => {
    if (
      trigger.trigger &&
      (trigger.trigger.classList.contains("timeline-item") || trigger.trigger.classList.contains("timeline"))
    ) {
      trigger.kill();
    }
  });

  if (timelineProgress && timeline) {
    ScrollTrigger.create({
      trigger: timeline,
      start: "top 80%",
      end: "bottom 20%",
      onUpdate: (self) => {
        const progress = self.progress * 100;
        timelineProgress.style.height = `${progress}%`;
      },
      invalidateOnRefresh: true,
    });
  }

  timelineItems.forEach((item, index) => {
    gsap.set(item, {
      opacity: 0,
      filter: "blur(15px)",
      transform: "translate3d(0, 50px, 0)",
    });

    ScrollTrigger.create({
      trigger: item,
      start: "top 85%",
      onEnter: () => {
        gsap.to(item, {
          opacity: 1,
          transform: "translate3d(0, 0, 0)",
          filter: "blur(0px)",
          duration: 0.8,
          ease: "power2.out",
        });
      },
      invalidateOnRefresh: true,
    });

    ScrollTrigger.create({
      trigger: item,
      start: "top 60%",
      end: "bottom 50%",
      onEnter: () => {
        setActiveItem(item, timelineItems);
      },
      onLeave: () => {
        item.classList.remove("active");
      },
      onEnterBack: () => {
        setActiveItem(item, timelineItems);
      },
      onLeaveBack: () => {
        item.classList.remove("active");
      },
      invalidateOnRefresh: true,
    });
  });
}

function setActiveItem(activeItem, allItems) {
  allItems.forEach((item) => {
    item.classList.remove("active");
  });

  activeItem.classList.add("active");
}

let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    ScrollTrigger.refresh();
  }, 250);
});

document.addEventListener("DOMContentLoaded", initTimelineReveal);
document.addEventListener("page:loaded", initTimelineReveal);
